type CollectionOwnership = {
  owner: { displayName: string };
  owners?: readonly { displayName: string }[];
};

export function collectionOwnerLabel(collection: CollectionOwnership) {
  const owners = collection.owners?.length
    ? collection.owners
    : [collection.owner];
  return owners.map((owner) => owner.displayName).join("・");
}

export function collectionHasCoOwners(collection: CollectionOwnership) {
  return (collection.owners?.length ?? 0) > 1;
}
